﻿window.MathJax = {
    options: {
        enableMenu: false
    },
    tex: {
        displayMath: [['\\[', '\\]']] 
    },
    svg: {
        fontCache: 'global',
        scale: 1.5,
        accessibility: {
            speech: true,
            collapsible: true
        }
    },
    ally: {
        speech: {
            speakText: true
        }
    }
};

var script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js';
script.setAttribute('id', 'MathJax-script');
document.head.appendChild(script);